// src/api_scripts/createCADVariable.js
import { createApiClient } from "../apiClient";

const createCADVariable = async (cadvariableData, orgId, accessToken, setProgress) => {
  const { name } = cadvariableData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create CAD Variable: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // API endpoint for creating a new  CAD Variable
  const relativeUri = `organization/${orgId}/cad-variable`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, cadvariableData);

    const newCADVariable = response.data; // The API returns the created resource directly

    console.log("Create CAD Variable API Response Data:", newCADVariable);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created CAD Variable "${name}" (ID: ${newCADVariable.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newCADVariable.id; // Return the created override list object (includes its ID)

  } catch (error) {
    console.error(`Error creating CAD Variable "${name}":`, error);

    let errorMessage = `Error creating CAD Variable "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createCADVariable;
